// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"170":"bindphone","377":"chat","583":"drawing"}[chunkId] || chunkId) + ".1740882488364.js";
};